import { isAccessToken, isIDToken, isRefreshToken } from "@okta/okta-auth-js";
export var getTokenValue = function (token) {
  if (isAccessToken(token)) return token.accessToken;
  if (isRefreshToken(token)) return token.refreshToken;
  if (isIDToken(token)) return token.idToken;
  throw new Error("Could not find token value: unhandled token type.");
};